import React from "react";
import { InvoiceController } from "./InvoiceController";
import { InvoiceViewModel } from "./InvoiceViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class InvoiceProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new InvoiceViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <InvoiceController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Invoice/InvoiceProvider.js